import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleCallback, login } from "./oidc";

export function Callback() {
  const navigate = useNavigate();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { returnUrl } = await handleCallback();
        if (!cancelled) navigate(returnUrl, { replace: true });
      } catch (err) {
        if (import.meta.env.DEV) {
          console.warn("[oidc] callback failed", err);
        }
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error(String(err)));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="tawa-app loading">
        <p>Erreur de connexion. Merci de réessayer.</p>
        <button onClick={() => void login()}>Réessayer</button>
      </div>
    );
  }

  return <div className="tawa-app loading">Connexion en cours…</div>;
}
